import { useQuery } from '@tanstack/react-query';
import { projectsDb } from '../../lib/db/index.js';
import type { Project } from '../../types/project.js';

/**
 * 投稿フォームで「プロジェクト」セレクタに表示する候補。
 * shared プロジェクト + 自分の private プロジェクトを merge + dedup（id 基準）。
 *
 * 投稿者目線で「リンク可能な全プロジェクト」を返す。並び順:
 * 1. 自分のプロジェクト（最新作成順）
 * 2. 他人の shared プロジェクト（最新作成順）
 */
export function useAvailableProjects(uid: string | undefined) {
  return useQuery<Project[]>({
    queryKey: ['projects', 'available', uid ?? null],
    queryFn: async () => {
      if (!uid) return [];
      const [shared, mine] = await Promise.all([
        projectsDb.findShared({ count: 200 }),
        projectsDb.findByOwner(uid, { count: 200 }),
      ]);
      const seen = new Set<string>();
      const out: Project[] = [];
      // 自分のものを優先（private 含む）
      for (const p of mine) {
        if (!seen.has(p.id)) {
          seen.add(p.id);
          out.push(p);
        }
      }
      for (const p of shared) {
        if (!seen.has(p.id)) {
          seen.add(p.id);
          out.push(p);
        }
      }
      return out;
    },
    enabled: !!uid,
    staleTime: 60_000,
  });
}
